var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apoios',{attrs:{"apoios":_vm.apoios,"apoiosServicos":_vm.obterServicos(),"permiteInserir":_vm.$temAcessoView('GESCON-GER-APOIO-01'),"permiteExcluir":_vm.$temAcessoView('GESCON-GER-APOIO-01')},on:{"obterApoiosAtualizados":function($event){return _vm.obterApoios()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }